import fs from 'node:fs'
import path from 'node:path'
import type { GeneratedFile } from '@cli-types/core-engine/schema.js'
import type { SnapshotManifestFile } from '@cli-types/core-engine/snapshots.js'
import { hashContent } from '@cli-utils/files.js'
import { filesDir } from './files-dir.js'
import { snapshotFilePath } from './snapshot-file-path.js'

export function writeSnapshotFiles(
  cwd: string,
  scope: string,
  files: GeneratedFile[]
): SnapshotManifestFile[] {
  const dir = filesDir(cwd, scope)
  fs.rmSync(dir, { recursive: true, force: true })
  fs.mkdirSync(dir, { recursive: true })

  return files.map((file) => {
    const outputPath = snapshotFilePath(cwd, scope, file.path)
    fs.mkdirSync(path.dirname(outputPath), { recursive: true })
    fs.writeFileSync(outputPath, file.content, 'utf-8')
    return {
      path: file.path,
      hash: hashContent(file.content)
    }
  })
}
